import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import images from './images'
import { BrowserRouter, Routes, Route} from "react-router"

import { database } from "./firebaseConfig2";
import Josh from "./components/josh"
import joshwhistle from "./other-assets/joshed.mp3";
import AudioPlayer from "./components/audio-player"
import Photocards from "./components/photocards"
import Adoptable from "./components/adoptable"
import About from './components/about';
import Blog from './components/blog';

import fanlistings from './components/object-lists/fanlistings';
import stamps from './components/object-lists/stamps';
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import Hatchery from './components/hatchery';
import Webring1 from './components/webring1';
import Library from './components/library';
import Home from './Home';
import BookPage from './components/library-page/book-page';


function App() {
    // console.log("In APP");

    function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
        }
      return array;
    }


  return (
    <BrowserRouter>
     <Routes>
      <Route path="/" element={<Home/>}  />
      <Route path="/about" element={<About/>}  />
      <Route path="/library" element={<Library/>}  />
      <Route path="/library/:id" element={<BookPage/>}/>
      <Route path="/hatchery" element={<Hatchery shuffle={shuffle} />}  />


    </Routes>
     
      </BrowserRouter>
  );
}

export default App;
